// Chapter 1 — narrated introduction.
// First content extracted from App.tsx into the locale-keyed content tree.
// Same Hebrew text, same join order — no behavioural change. The point
// is to prove the i18n shape so subsequent chapters and locales drop in
// here without touching App.tsx structure.

export const T1 =
  "הידעתם? בכל פעם שאתם חווים רגש שלילי, פחד, כעס, תסכול, קנאה, אכזבה, שנאה, עלבון, ייאוש, ובמיוחד כשאין איום ממשי ומיידי על החיים עצמם, אתם משלמים מחיר. האם הכרתם את ההשפעות האמיתיות? אם התעורר אצלכם ספק קטן, אולי יש כאן אמת, אז קחו את הספר וקראו.";

export const T2 =
  "הרגשות משפיעים על בריאותנו ואיכות חיינו. אינטליגנציה רגשית, היכולת לזהות רגשות, להבין את מקורותיהם ולנהל אותם באופן מיטבי, היא אחת המיומנויות החשובות ביותר לחיים בעולם המודרני. הספר הזה נכתב כדי לגשר על הפער ולהפוך את הבלתי מודע למודע. זהו מסע אישי, חברתי ואנושי והוא מתחיל כאן.";

export const T3 =
  "בלמעלה מ-95 אחוז מהמקרים שבהם עולה רגש שלילי, אין שום סכנה אמיתית של מוות. כל שאר הרגשות השליליים כמו כעס, בושה, קנאה, שנאה, עלבון, רוגז, תסכול אינם אלא ענפים של אותו שורש עמוק ועתיק, פחד המוות. בכל אחד מאיתנו פועלת מערכת הישרדות שירשנו. ואותה מערכת שכמעט לא השתנתה מאז, מלווה אותנו גם היום.";

export const T4 =
  "אני במרכז ועל עצמי אני כותב. לא על איך שנדמה לכם שאתם נראים בעיני אחרים, אלא על איך שאתם חושבים שאתם. רוב האנשים כותבים בהתחלה את מה שאחרים חושבים עליהם. כאן אתם לא צריכים להרשים אף אחד. זו הזדמנות נדירה פשוט להיות עם עצמכם. תכתבו באומץ ובאותנטיות.";

export const T5 =
  "כל פעם שעולה לכם רגש שלילי ואתם מצליחים לזהות אותו, עצרו, קחו נשימה עמוקה ושאלו את עצמכם: האם יש כאן באמת סכנת מוות מיידית? ושחררו. אם הרגש השלילי נעלם, הצלחתם. יש סיכוי רב שהתרגיל הזה ימתן את הרגשות השליליים שלכם. בשלב מסוים התרגיל הזה יהפוך להרגל נפלא.";

export const TALL = T1 + " " + T2 + " " + T3 + " " + T4 + " " + T5;

export const FIELDS_DATA = [
  { id: "q1", label: "מה מייחד אותך רגשית?" },
  { id: "q2", label: "אילו תכונות את מזהה בעצמך?" },
  { id: "q3", label: "מה את אוהבת בעצמך?" },
  { id: "q4", label: "כמה את באמת נותנת מקום לתכונות האלו ביום-יום?" },
];
